import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "app-mech-empty",
	templateUrl: "./mech-empty.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ["./mech-empty.component.scss"]
})
export class MechEmptyComponent {

}
